import {create} from "zustand";
import axios from "axios";
import Swal from "sweetalert2";

const normatecaStore = create((set, get) => ({

    opcVis: "",
    indices: "",
    indicesLatSel:"",
    opcMenu:"",
    isLoading: false,
    menuEncabezado:[],
    menuMateria:[],
    menuLat:{},
    menuSupMat:{},
    menuSupSub:{},
    infoRes:[],
    documentosOriginal:[],
    documentos:[],
    marcoJ:{},
    indiceMarcoJ:-1,
    setObjError:"",
    banVigAnt:"vig",
    indiceOrden:0,
    tipoOrdenaB:["Proximidad","Orden alfabético","Fecha de publicación más reciente","Fecha de publicación más antigua"],
    tipoOrdena:["Orden alfabético","Fecha de publicación más reciente","Fecha de publicación más antigua"],
    materiaSel:"Materia",
    submateriaSel:"Submateria",
    pagina0:-1,
    indiceInicio:0,
    ordenamiento:"",
    txtOrden:"Ordenar por: ",
    txtBusqueda: "",
    buscaInputValue:"",
    buscaInputValueAva:"",
    tipoFiltro:["Documentos vigentes","Documentos anteriores"],
    filtrar:"",
    txtFiltrar:"Filtrar por: ",
    indiceFiltro:0,
    menuBusAva:[],
    menuBusAvaEmisor:[],
    envio:false,
    intra:false,//si es usuario inegi desde intranet o es de sitio expuesto
    visMenu1:false,
    visMenu2:false,
    visMenu3:false,
    visMenu4:false,
    visEnc:false,
    visMenuMovil:false,
    jsonDeInteres:[],
    jsonMasConsultado:[],
    jsonMasConsultadoOriginal:[],
    jsonMasLeido:[],
    jsonPublicRecientes:[],
    jsonSitiosAfines:[],
    jsonMasInfo:[],
    busClasif:"",
    busOrden: "",
    openDivLoading:false,
    correoNorma:[],
    indMateria:-1,
    dispMax:10,
    listaUnidAdminEsp:["0200-1000"],// unidades administrativas especiales que contienen unidades como subnivel
    setE:false,
    //Cambiar valores de variables globales según la opción seleccionada del menu
    setContenido: async (opcVis,indices, opcMenu) => {
        try {
            set({ opcVis:opcVis }); 
            set({buscaInputValue:""});
            set({buscaInputValueAva:""});
            set({visEnc:false});

            if(opcMenu!=="bus" && opcMenu!=="busAva" && opcMenu!=="busAvaOpc"){
                  set({txtBusqueda:""});
            }
            if(opcMenu!=="menuLat"){
                  set({ indices: indices });
            }
            set({ opcMenu: opcMenu });
            //("opcMenu",opcMenu);
            //si es inicio, limpiar variables
            if (opcVis==="Inicio"){
                  set({indicesLatSel:""});
                  set({indices: ""});
                  set({menuLat:{}});
                  set({menuSupMat:{}});
                  set({menuSupSub:{}});
                  set({infoRes:[]});
                  set({documentos:[]});
                  set({marcoJ:{}});
                  set({indiceMarcoJ:-1});
                  set({banVigAnt:"vig"});
                  set({indiceIni:0});
                  set({indiceFin:0});
                  set({pagina0:-1});
                  set({indiceInicio:0});
                  set({indiceOrden:0});
                  set({ordenamiento:""});
                  set({txtBusqueda:""});
                  set({filtrar:""});
                  set({buscaInputValue:""});
                  set({buscaInputValueAva:""});
                  set({menuBusAva:[]});
                  set({visEnc:false});
                  set({menuBusAvaEmisor:[]});
            }
         } catch (error) {
              console.log("error aut", error);
              set({setObjError:"Error"});
        } finally {
              set( { isLoading: false } );
        }
    },
    //Obtener la información para generar el menú del encabezado
    getMenuEncabezado: async () => {
       try {
       const apiurl = process.env.REACT_APP_API_URL; 
       const response = await axios.post(apiurl + 'temas/ObtenerMenu');
            set({ menuEncabezado: []});
            let menuTemp= [...response.data];
            let masConsultado= [];
            let masConsultadoOrden=[];
            let mc={};
            menuTemp.map((mt,indexmt)=>{
                  if (mt.nombre==="Materia")
                        mt.nombre="Consulta de Marco Normativo por Materia";
                  if(mt.nivel2){
                        mt.nivel2.map ((m,index)=>{
                              m.visualiza=false;
                              mc={};
                              if(m.id.substring(0,4)==="0400")
                              {
                                    mc.value=m.nombre.trim();
                                    if (m.nivel3){
                                          mc.id=m.nivel3[0].id;
                                          mc.idTipo= m.nivel3[0].idTipo;
                                    }
                                    else{
                                          mc.id=m.id;
                                          mc.idTipo= m.idTipo;
                                    }
                                    mc.inds = index.toString() + "-" + "0";
                                    mc.tipo= "0400";
                                    mc.menu="menuMat";
                                    masConsultado.push(mc);
                              }
                              if (m.nivel3){
                                    m.nivel3.map ((m1,index1)=>{
                                          m1.visualiza=false;
                                          if (m1.id.substring(0,4)==="0400"){
                                                mc={};
                                                mc.value=m1.nombre.trim();
                                                mc.id=m1.id;
                                                mc.idTipo= m1.idTipo;
                                                mc.inds = index.toString() + "-" + index1.toString();
                                                mc.tipo= "0400";
                                                mc.menu="menuMat";
                                                masConsultado.push(mc);
                                          }
                                          if(m1.nivel4){
                                                m1.nivel4.map ((m2,index2)=>{
                                                m2.visualiza=false;
                                                if (m2.id.substring(0,4)==="0400"){
                                                      mc={};
                                                      mc.value=m2.nombre.trim();
                                                      mc.id=m2.id;
                                                      mc.idTipo= m2.idTipo;
                                                      mc.inds = index.toString() + "-" + index1.toString() + "-" + index2.toString();
                                                      mc.tipo= "0400";
                                                      mc.menu="menuMat";
                                                      masConsultado.push(mc);
                                                }
                                                })
                                          }
                                    })
                              }
                  
                        })
                  }
            })
            //console.log("masconsultado***", masConsultado);
            set({ jsonMasConsultadoOriginal: masConsultado});//original desde BD
            set({ menuEncabezado: menuTemp});
            sessionStorage.setItem('menuEncabezado', JSON.stringify(menuTemp));
      } catch (error) {
            console.log("error aut", error);
            set({setObjError:"Error"});
            return(get().setObjError); 
      }
      finally {
            set( { isLoading: false } );
      } 
    },
    //Obtener la información de despliegue para los documentos  (viene de menú encabezado)
   getInfoEnc: async (opc,idTipo,tipo,tit,subtit,introT,introS) => {
      const apiurl = process.env.REACT_APP_API_URL; 
      try {
      //llamada al API
      let param={
            titulo:tit,
            introTit:introT,
            introSub:introS,
            subtitulo:subtit,
            idTipo: idTipo,
            tipo:tipo
      }
      let header={
            "headers": {
              "Content-Type": "application/json",
              "accept": "application/json, text/plain, */*"
          }
        }
      let info=[];
      const response = await axios.post(apiurl + 'disposiciones/ObtenerDisposiciones',JSON.stringify(param),header);
            //axios.get(archivojson)
            //.then(function (response) {
                  info=response.data[0];
                  set({documentosOriginal:[]});
                  set({indiceInicio:0});
                  set({indiceOrden:0});
                  set({ordenamiento:get().txtOrden + get().tipoOrdena[0]});
                  set({ infoRes: []});
                  set({ marcoJ: {}});
                  set({indiceMarcoJ: -1});
                  set({banVigAnt: "vig"});
                  set({documentos:[]});
                  let indMarcoJuri=-1;
                  let infoV1= info.vigentes.filter((if1)=>if1.titulo.includes(info.titulo));
                  let infoV2= info.vigentes.filter((if2)=>!if2.titulo.includes(info.titulo));
                  info.vigentes= infoV1.concat(infoV2);
                  if(info.anteriores!==null && info.anteriores.length>0){
                        info.anteriores.map((ant)=>{
                              ant.visual=false;
                              ant.archivos.map((anta)=>{
                                    let archsA=anta.nombreArchivo.split(",");
                                    anta.listaArchivos= archsA;
                              })
                              ant.instruapoyo.map((inst)=>{
                                    let archIp=inst.nombreArchivo.split(",");
                                    inst.listaArchivos= archIp;
                              })
                              //ordenamiento cronológico de fechas de archivos
                              ant.archivos= ant.archivos.sort((a, b) =>
                                    new Date(...a.fechaFormato.split('/').reverse()) - new Date(...b.fechaFormato.split('/').reverse())
                              );
                        })
                  }
                  if(info.documentosGral!==null){
                        info.documentosGral.map((d)=>{
                              //cambiar a true para que los intrumentos de apoyo estén visibles al iniciar
                              d.visualins=false;//true
                         })
                        set({documentos: info.documentosGral});
                        indMarcoJuri= info.documentosGral.findIndex((m)=> m.marcojuridico===true);
                        if (indMarcoJuri!==-1){
                              set({marcoJ: info.documentosGral[indMarcoJuri]});
                              set({indiceMarcoJ: indMarcoJuri});
                        }
                        set({banVigAnt: "vig"});
                  }
                  else{
                        if(info.vigentes!==null && info.vigentes.length>0){
                              info.vigentes.map((v)=>{
                                   //cambiar a true para que los intrumentos de apoyo estén visibles al iniciar 
                                   v.visualins=false;//true
                                   v.archivos.map((vta)=>{
                                    let archsV=vta.nombreArchivo.split(",");
                                    vta.listaArchivos= archsV;
                                   })
                                   v.instruapoyo.map((inst)=>{
                                    let archIp=inst.nombreArchivo.split(",");
                                    inst.listaArchivos= archIp;
                                   })
                              })
                              set({documentos: info.vigentes});
                              set({banVigAnt: "vig"});
                              indMarcoJuri= info.vigentes.findIndex((m)=> m.marcojuridico===true);
                              if (indMarcoJuri!==-1){
                                    set({marcoJ: info.vigentes[indMarcoJuri]});
                                    set({indiceMarcoJ: indMarcoJuri});
                              }
                        }
                        else  if(info.anteriores!==null && info.anteriores.length>0){
                                    set({documentos: info.anteriores});
                                    indMarcoJuri= info.anteriores.findIndex((m)=> m.marcojuridico===true);
                                    if (indMarcoJuri!==-1){
                                          set({marcoJ: info.anteriores[indMarcoJuri]});
                                          set({indiceMarcoJ: indMarcoJuri});
                                    }
                              }
                        if((info.vigentes===null || info.vigentes.length===0)  && (info.anteriores!==null || info.anteriores.length>0)){set({banVigAnt: "ant"});}
                  }
                  //let docs = [...get().documentos];
                  let docs = [...get().documentos].sort((a, b) =>
                                    a.titulo.toLowerCase() > b.titulo.toLowerCase() ? 1 : -1,
                        );
                  if (docs.length>get().dispMax){set({pagina0:0});}
                  else{set({pagina0:-1});}
                  set({documentos: docs});
                  set({documentosOriginal: JSON.parse(JSON.stringify(docs))});
                  set({ infoRes: info});
                  set({indiceOrden:0});
           /* })
            .catch((error) => {
            console.log(error);
            });*/
       } catch (error) {
             console.log("error aut", error);
             set({setObjError:"Error"});
             return(get().setObjError); 
       } finally {
             set( { isLoading: false } );
       } 
   },
   //Obtener la información de despliegue para los documentos  (viene de menú materia)
   getInfoMat: async (opc,idTipo,tipo,tit,subtit,introT,introS) => {
      const apiurl = process.env.REACT_APP_API_URL; 
      try {
            //llamada al API
            let param={
                  titulo:tit,
                  introTit:introT,
                  introSub: introS,
                  subtitulo:subtit,
                  idTipo: idTipo,
                  tipo:tipo
            }
            let header={
                  "headers": {
                    "Content-Type": "application/json",
                    "accept": "application/json, text/plain, */*"
                }
              }
            let info=[];
            const response = await axios.post(apiurl + 'disposiciones/ObtenerDisposiciones',JSON.stringify(param),header);

                 // axios.get(archivojson)
                 // .then(function (response) {
                        info=response.data[0];
                        set({indiceInicio:0});
                        set({indiceOrden:0});
                        set({ordenamiento:get().txtOrden + get().tipoOrdena[0]});
                        set({infoRes: []});
                        set({ marcoJ: {}});
                        set({indiceMarcoJ: -1});
                        set({banVigAnt: "vig"});
                        set({documentos:[]});
                        set({documentosOriginal:[]});
                        let indMarcoJuri=-1;
                        if(info.anteriores!==null && info.anteriores.length>0){
                              info.anteriores.map((ant)=>{
                                    ant.visual=false;
                                    ant.archivos.map((anta)=>{
                                          let archsA=anta.nombreArchivo.split(",");
                                          anta.listaArchivos= archsA;
                                    })
                                    ant.instruapoyo.map((inst)=>{
                                          let archIp=inst.nombreArchivo.split(",");
                                          inst.listaArchivos= archIp;
                                    })
                                    //ordenamiento cronológico de fechas de archivos
                                    ant.archivos= ant.archivos.sort((a, b) =>
                                    new Date(...a.fechaFormato.split('/').reverse()) - new Date(...b.fechaFormato.split('/').reverse())
                              );
                              })
                        }
                        if(info.documentosGral!==null){
                              info.documentosGral.map((v)=>{
                                    //cambiar a true para que los intrumentos de apoyo estén visibles al iniciar
                                    v.visualIns=false;//true
                               })
                              set({documentos: info.documentosGral});
                              set({banVigAnt: "vig"});
                              indMarcoJuri= info.documentosGral.findIndex((m)=> m.marcojuridico===true);
                              if (indMarcoJuri!==-1){
                                    set({marcoJ: info.documentosGral[indMarcoJuri]});
                                    set({indiceMarcoJ: indMarcoJuri});
                              }
                        }
                        else{
                              if(info.vigentes!==null && info.vigentes.length>0){
                                    info.vigentes.map((v)=>{
                                          //cambiar a true para que los intrumentos de apoyo estén visibles al iniciar
                                          v.visualIns=false;//true
                                          v.archivos.map((vta)=>{
                                                let archsV=vta.nombreArchivo.split(",");
                                                vta.listaArchivos= archsV;
                                          })
                                          v.instruapoyo.map((inst)=>{
                                                let archIp=inst.nombreArchivo.split(",");
                                                inst.listaArchivos= archIp;
                                          })
                                     })
                                    set({documentos: info.vigentes});
                                    set({banVigAnt: "vig"});
                                    indMarcoJuri= info.vigentes.findIndex((m)=> m.marcojuridico===true);
                                    if (indMarcoJuri!==-1){
                                          set({marcoJ: info.vigentes[indMarcoJuri]});
                                          set({indiceMarcoJ: indMarcoJuri});
                                    }
                              }
                              else if(info.anteriores!==null && info.anteriores.length>0){
                                          set({documentos: info.anteriores});
                                          indMarcoJuri= info.anteriores.findIndex((m)=> m.marcojuridico===true);
                                          if (indMarcoJuri!==-1){
                                                set({marcoJ: info.anteriores[indMarcoJuri]});
                                                set({indiceMarcoJ: indMarcoJuri});
                                          }
                                    }
                              if((info.vigentes===null || info.vigentes.length===0)  && (info.anteriores!==null || info.anteriores.length>0)){set({banVigAnt: "ant"});}
                        }
                        //let docs = [...get().documentos];
                        let docs = [...get().documentos].sort((a, b) =>
                                          a.titulo.toLowerCase() > b.titulo.toLowerCase() ? 1 : -1,
                              );
                        if (docs.length>get().dispMax){set({pagina0:0});}
                        else{set({pagina0:-1});}
                        set({documentos: docs});
                        set({documentosOriginal: JSON.parse(JSON.stringify(docs))});
                        set({infoRes: info});
                        set({indiceOrden:0});
                 /* })
                  .catch((error) => {
                  console.log(error);
                  });*/

                 
             } catch (error) {
                   console.log("error aut", error);
                   set({setObjError:"Error"});
                   return(get().setObjError); 
             } finally {
                   set( { isLoading: false } );
             } 
   },
   //cambia información de documentos Vigentes - Anteriores
   setCambiaVigAnt: async (opcVigAnt,opc) => {
      try {
      //llamada al API
           set({ documentos: []});
           set({indiceInicio:0});
           set({indiceOrden:0});
           set({banVigAnt: ""});
           let doc= get().infoRes;
           let docs=[];
           switch(opcVigAnt){
            case "vig":
                  switch(opc){
                        case "m":
                              set({ordenamiento:get().txtOrden + get().tipoOrdena[0]});
                              docs = [...doc.vigentes].sort((a, b) => a.titulo.toLowerCase() > b.titulo.toLowerCase() ? 1 : -1, );
                        break;
                        case "b":
                              set({ordenamiento:get().txtOrden + get().tipoOrdenaB[0]});
                              docs = [...doc.vigentes];
                        break;
                  }
                  set({banVigAnt: "vig"});
                  break;
            case "ant":
                  switch(opc){
                        case "m":
                              set({ordenamiento:get().txtOrden + get().tipoOrdena[0]});
                              docs = [...doc.anteriores].sort((a, b) => a.titulo.toLowerCase() > b.titulo.toLowerCase() ? 1 : -1, );
                              break;
                        case "b":
                              set({ordenamiento:get().txtOrden + get().tipoOrdenaB[0]});
                              docs = [...doc.anteriores];
                        break;
                  }
                  set({banVigAnt: "ant"});
                  break;
            default:
                  break;
           }
           if (docs.length>get().dispMax){set({pagina0:0});}
           else{set({pagina0:-1});}
           set({ documentos: docs});
       } catch (error) {
             console.log("error aut", error);
             set({setObjError:"Error"});
             return(get().setObjError); 
       } finally {
             set( { isLoading: false } );
       } 
   },
   //obtener el menú de lado Lateral (Navegación)
   setObtenerMenuLat: async (indiMenu) => {
      let ind= get().indices.toString().split("-");
      let menuTemp;
      if (get().menuEncabezado.length===0){
            menuTemp= JSON.parse(sessionStorage.getItem('menuEncabezado'));
      }
      else{
            menuTemp= JSON.parse(JSON.stringify(get().menuEncabezado));
      }
      let indTemp="";
      menuTemp[parseInt(indiMenu)].nivel2.map ((m,index)=>{
            if (parseInt( ind[0])===index){
                  indTemp= index.toString();
                  m.seleccionado=true;
                  m.visualiza=true;
            }
            else {
                  m.seleccionado=false;
                  m.visualiza=false;
            }
            if (m.nivel3){
                  m.nivel3.map ((m1,index1)=>{
                        if (parseInt(ind[1])===index1 && parseInt( ind[0])===index){
                              m1.seleccionado=true;
                              indTemp= indTemp + "-" + index1;
                              m1.visualiza=true;
                        }
                        else {
                              m1.seleccionado=false;
                              m1.visualiza=false;
                        }
                        if(m1.nivel4){
                              m1.nivel4.map ((m2,index2)=>{
                                    if (parseInt(ind[2])===index2 && parseInt(ind[1])===index1 && parseInt( ind[0])===index){
                                          m2.seleccionado=true;
                                          indTemp = indTemp + "-" + index2;
                                          m2.visualiza=true;
                                    }
                                    else {
                                          m2.seleccionado=false;
                                          m2.visualiza=false;
                                    }
                              })
                        }
                  })
            }

      })
      set({menuLat: menuTemp[parseInt(indiMenu)]});
      set({indicesLatSel: indTemp});
   },

//obtener el menú Superior (Materia)
setObtenerMenuSup: async () => {
      set({menuSupMat:{}});
      set({menuSupSub:{}});
      let ind= get().indices.split("-");
      let menuTemp;
      if (get().menuEncabezado.length===0){
            menuTemp= JSON.parse(sessionStorage.getItem('menuEncabezado'));
      }
      else{
            menuTemp= [...get().menuEncabezado];
      }
      set({indMateria: ind[0]});
      set({menuSupMat: menuTemp[3].nivel2});
      set({materiaSel: "Materia: " + menuTemp[3].nivel2[ind[0]].nombre });
      if (ind.length===2){
            set({menuSupSub: menuTemp[3].nivel2[ind[0]].nivel3}); 
            set({submateriaSel: "Submateria: " + menuTemp[3].nivel2[ind[0]].nivel3[ind[1]].nombre });
      }
  },
//obtener el menú marco normativo para el buscador
setObtenerMenuBusAva: async () => {
      try{
            set({ menuBusAva: []});
            const apiurl = process.env.REACT_APP_API_URL; 
            const response = await axios.post(apiurl + 'emisor/ObtenerMenuUnidAdmin');
            let menuTemp= [...response.data];
            menuTemp.map ((m,index)=>{
                  m.visualiza=false;
            }) 
            set({menuBusAva: menuTemp});
            return(menuTemp);
            } catch (error) {
                  console.log("error aut", error);
                  set({setObjError:"Error"});
                  return(get().setObjError); 
            } finally {
                  set( { isLoading: false } );
            } 
         },
   setObtenerMenuBusAvaEmisor: async () => {
      try{
      set({ menuBusAvaEmisor: []});
      const apiurl = process.env.REACT_APP_API_URL; 
      const response = await axios.post(apiurl + 'emisor/ObtenerMenuEmisor');
      let menuTempE= [...response.data];
      menuTempE.map ((m,index)=>{
            m.visualiza=false;
      }) 
      set({menuBusAvaEmisor: menuTempE});
      return(menuTempE);
      } catch (error) {
            console.log("error aut", error);
            set({setObjError:"Error"});
            return(get().setObjError); 
      } finally {
            set( { isLoading: false } );
      } 
   },
   //Abrir o cerrar opciones del menú de lado lateral (si tiene subnivel)
   setOpenCloseMenu: async (indis,menu) => {
      let ind= indis.toString().split("-");
      let menuI= menu;
      switch(ind.length){
           case 1:
               menuI.nivel2[ind[0]].visualiza= !menuI.nivel2[ind[0]].visualiza;
            break;
            case 2:
               menuI.nivel2[ind[0]].nivel3[ind[1]].visualiza= !menuI.nivel2[ind[0]].nivel3[ind[1]].visualiza;
            break;
            case 3:
                  menuI.nivel2[ind[0]].nivel3[ind[1]].nivel4[ind[2]].visualiza= !menuI.nivel2[ind[0]].nivel3[ind[1]].nivel4[ind[2]].visualiza;
            break;
            default:
                  break;
      }
      set({menuLat: menuI});
   },
   //Cambio de valor al objeto correspondiente para visualizar estilo 
   setSeleccionMenuLat: async (indis) => {
      let ind= indis.toString().split("-");
      let menuI= get().menuLat;
      if(get().indicesLatSel!== indis.toString()){
            menuI.nivel2.map ((m,index)=>{
                  m.visualiza=false;
                  m.seleccionado=false;
                  if (m.nivel3){
                        m.nivel3.map ((m1,index1)=>{
                          m1.seleccionado=false;
                          m1.visualiza=false;
                          if(m1.nivel4){
                              m1.nivel4.map ((m2,index2)=>{
                                m2.seleccionado=false;
                                m2.visualiza=false;
                              })
                          }
                        })
                  }
             })

            //cambiar valores a los objetos del menu de false a true para los indices nuevos
            switch(ind.length){
                  case 1:
                        menuI.nivel2[ind[0]].seleccionado= true;
                        menuI.nivel2[ind[0]].visualiza=false;
                  break;
                  case 2:
                        menuI.nivel2[ind[0]].seleccionado=true;
                        menuI.nivel2[ind[0]].visualiza=true;
                        menuI.nivel2[ind[0]].nivel3[ind[1]].seleccionado= true;
                        menuI.nivel2[ind[0]].nivel3[ind[1]].visualiza=true
                  break;
                  case 3:
                        menuI.nivel2[ind[0]].seleccionado=true;
                        menuI.nivel2[ind[0]].visualiza=true;
                        menuI.nivel2[ind[0]].nivel3[ind[1]].seleccionado= true;
                        menuI.nivel2[ind[0]].nivel3[ind[1]].visualiza=true;
                        menuI.nivel2[ind[0]].nivel3[ind[1]].nivel4[ind[2]].seleccionado= true;
                        menuI.nivel2[ind[0]].nivel3[ind[1]].nivel4[ind[2]].visualiza=true;
                  break;
                  default:
                        break;
            }
            set({indicesLatSel: indis});
            set({menuLat: menuI});
      }
   },
   //ordena el listado de documentos 
   setOrdenar: async (orden,opc)=>{
      let documentosTemp= get().documentos;
      let documentosOrigTemp= get().documentosOriginal;
      let docs=[];
      switch (opc){
         case "m":
            switch (orden){
                  case 0://orden alfabético
                        docs = [...documentosTemp].sort((a, b) =>
                              a.titulo.toLowerCase() > b.titulo.toLowerCase() ? 1 : -1,
                        );
                   break;
                  case 1://Fecha de publicación más reciente
                        if (get().banVigAnt==="vig"){
                              docs = documentosTemp.sort((a, b) =>
                                    new Date(...b.archivos[0].fechaFormato.split('/').reverse()) - new Date(...a.archivos[0].fechaFormato.split('/').reverse())
                              );
                        }
                        else{
                              /*documentosTemp.map((dt)=>{
                                    dt.archivos= dt.archivos.sort((a, b) =>
                                          new Date(...b.fechaFormato.split('/').reverse()) - new Date(...a.fechaFormato.split('/').reverse())
                                    );
                              })*/
                              docs = documentosTemp.sort((a, b) =>
                                    new Date(...b.archivos[b.archivos.length-1].fechaFormato.split('/').reverse()) - new Date(...a.archivos[a.archivos.length-1].fechaFormato.split('/').reverse())
                              );
                        }
       
                  break;
                  case 2://Fecha de publicación más antigua
                        docs = documentosTemp.sort((a, b) =>
                              new Date(...a.archivos[0].fechaFormato.split('/').reverse()) - new Date(...b.archivos[0].fechaFormato.split('/').reverse())
                        );
                        /* if (get().banVigAnt==="vig"){
                              docs = documentosTemp.sort((a, b) =>
                                    new Date(...a.archivos[0].fechaFormato.split('/').reverse()) - new Date(...b.archivos[0].fechaFormato.split('/').reverse())
                              );
                        }
                        else{
                              documentosTemp.map((dt)=>{
                                    dt.archivos= dt.archivos.sort((a, b) =>
                                          new Date(...a.fechaFormato.split('/').reverse()) - new Date(...b.fechaFormato.split('/').reverse())
                                    );
                              }) 
                              docs = documentosTemp.sort((a, b) =>
                                    new Date(...a.archivos[0].fechaFormato.split('/').reverse()) - new Date(...b.archivos[0].fechaFormato.split('/').reverse())
                              );
                        } */
                  break;
                  default:
                        break;
            }
            set({indiceOrden:orden});
            set({ordenamiento: get().txtOrden + get().tipoOrdena[orden]});
            break;
         case "b":
            switch (orden){
                  case 0://orden alfabético
                        docs = [...documentosOrigTemp];
                   break;
                  case 1://orden alfabético
                        docs = [...documentosTemp].sort((a, b) =>
                              a.titulo.toLowerCase() > b.titulo.toLowerCase() ? 1 : -1,
                        );
                   break;
                  case 2://Fecha de publicación más reciente
                        if (get().banVigAnt==="vig"){
                              docs = documentosTemp.sort((a, b) =>
                                    new Date(...b.archivos[0].fechaFormato.split('/').reverse()) - new Date(...a.archivos[0].fechaFormato.split('/').reverse())
                              );
                        }
                        else{
                              /*documentosTemp.map((dt)=>{
                                    dt.archivos= dt.archivos.sort((a, b) =>
                                          new Date(...b.fechaFormato.split('/').reverse()) - new Date(...a.fechaFormato.split('/').reverse())
                                    );
                              })*/
                              docs = documentosTemp.sort((a, b) =>
                                    new Date(...b.archivos[b.archivos.length-1].fechaFormato.split('/').reverse()) - new Date(...a.archivos[a.archivos.length-1].fechaFormato.split('/').reverse())
                              );
                        }
       
                  break;
                  case 3://Fecha de publicación más antigua
                        docs = documentosTemp.sort((a, b) =>
                              new Date(...a.archivos[0].fechaFormato.split('/').reverse()) - new Date(...b.archivos[0].fechaFormato.split('/').reverse())
                        );
                        /* if (get().banVigAnt==="vig"){
                              docs = documentosTemp.sort((a, b) =>
                                    new Date(...a.archivos[0].fechaFormato.split('/').reverse()) - new Date(...b.archivos[0].fechaFormato.split('/').reverse())
                              );
                        }
                        else{
                              documentosTemp.map((dt)=>{
                                    dt.archivos= dt.archivos.sort((a, b) =>
                                          new Date(...a.fechaFormato.split('/').reverse()) - new Date(...b.fechaFormato.split('/').reverse())
                                    );
                              }) 
                              docs = documentosTemp.sort((a, b) =>
                                    new Date(...a.archivos[0].fechaFormato.split('/').reverse()) - new Date(...b.archivos[0].fechaFormato.split('/').reverse())
                              );
                        } */
                  break;
                  default:
                        break;
            }
            set({indiceOrden:orden});
            set({ordenamiento: get().txtOrden + get().tipoOrdenaB[orden]});
            break;
      }
      set({documentos: docs});
   },
   //Cambio de opción en el menú superior combo materia
   setCambiaMenuSupMat:async(indi)=>{
      let menuM= get().menuSupMat;
      set({indMateria: indi});
      set({menuSupSub: menuM[indi].nivel3}); 
      set ({materiaSel:"Materia: " + menuM[indi].nombre });
      set({submateriaSel: "Submateria"})
   },
   //Cambiar valor de la variable pagina0 para el paginado
   setCambiaPagSel:async (valor,indiceIni)=>{
      set({pagina0:valor});
      set({indiceInicio:indiceIni});
   },
   //busqueda
   llamadaBuscador: async(txtBus,clas,orden,metodo,marcoNor,unidEmi,radUnidAdmEmisor,filtroBus,marcoJur,manuales)=>{
      try {
            set({busClasif: clas});
            set({busOrden: orden});
            set({visEnc:false});
            const apiurl = process.env.REACT_APP_BUSCADOR; 
            let param={
                  "busqueda" : txtBus,
                  "paginaInicio" : 1,
                  "paginaFin" : 0,
                  "clasificacion":clas,
                  "marconormativa": unidEmi === "todo" && marcoJur!=="" && manuales==="todo"? "" : marcoNor==="marco normativo" && radUnidAdmEmisor==="ua"? "marco normativo > " + unidEmi.toLowerCase().trim(): marcoNor==="marco normativo" && radUnidAdmEmisor==="em" && unidEmi!=="todo"? "marco normativo":unidEmi,
                  "emisor":marcoNor==="marco normativo" && radUnidAdmEmisor==="em"? unidEmi.toLowerCase().trim():"",
                  "marcomanual": unidEmi === "todo" && marcoJur!=="" && manuales==="todo"? "": manuales,
                  "marcojuridico":unidEmi === "todo" && marcoJur!=="" && manuales==="todo"? "" : marcoJur,
                  "idioma": "es",
                  "filtrobusqueda" : filtroBus, //"cbusqueda",//cbusqueda= busca en titulo, temática, descripción,documentos 
                  "orderBy" : "ranking",
                  "orderbyAscDesc" : "desc",
                  "metodoBusqueda": metodo
                }
            let header={
                "headers": {
                  "Content-Type": "application/json",
                  "accept": "application/json, text/plain, */*"
              }
            }
            //llamada al api como promesa
            const response = await axios.post(apiurl,JSON.stringify(param),header);
          //  axios.post(apiurl,JSON.stringify(param),header)
          //  .then(function (response) {
                  let infoCambio= JSON.parse(JSON.stringify(response.data));
                  //console.log("respuestaBuscador***",infoCambio);
                  let docCambio=[];
                  let urlReplace= "https://sc.inegi.org.mx/repositorioNormateca/";
                  let urlReplace2= "http://sc.inegi.org.mx/repositorioNormateca/";

                  if (infoCambio!=="" && infoCambio!==null && infoCambio.length!==0){
                        docCambio.titulo="";
                        docCambio.introduccion="";
                        docCambio.subtitulo ="";
                        let vigentes=[];
                        let archivos=[];
                        let archivosInsAp=[];
                        let instruapoyo=[];
                        let anteriores=[];
                        let vig={};
                        let arc={};
                        let arcInsAp={};
                        let ant={};
                        let instAp={};
                        let filtroVig= infoCambio.filter((vg) => vg.CLASIFICACION.toLowerCase()==="vigente" && vg.IDNORMATIVAORIG===0);
                        let filtroInstApVig= infoCambio.filter((vg) => vg.CLASIFICACION.toLowerCase()==="vigente" && vg.IDNORMATIVAORIG!==0);
                        let filtroAnt= infoCambio.filter((an) => an.CLASIFICACION.toLowerCase()==="anterior" && an.IDNORMATIVAORIG===0);
                        let filtroInstApAnt= infoCambio.filter((vg) => vg.CLASIFICACION.toLowerCase()==="anterior" && vg.IDNORMATIVAORIG!==0);
                        let filtroAntDif = filtroAnt.filter((data,index,j)=> index === j.findIndex((t) => (t.TITULO.trim() === data.TITULO.trim())));
                        filtroVig.map((ic,index)=>{
                              vig={};
                              arc={};
                              archivos=[];
                              instruapoyo=[];
                              vig.titulo=ic.TITULO;
                              vig.marcojuridico=false;
                              vig.ruta = ic.TEMATICA;
                              arc.fechaPublicacion=ic.FECHA_PUBLICACION!=="" && ic.FECHA_PUBLICACION!==null ? ic.FECHA_PUBLICACION : "";
                              arc.fechaFormato = ic.FECHA!=="" && ic.FECHA!==null ? ic.FECHA : ""
                              arc.fechaVigor= ic.FECHA_VIGOR!=="" && ic.FECHA_VIGOR!==null ? ic.FECHA_VIGOR :  "";
                              arc.fechaReforma= ic.FECHA_REFORMA!=="" && ic.FECHA_REFORMA!==null ? ic.FECHA_REFORMA : "";
                              arc.fechaUltimaRefDof= ic.FECHA_ULTIMA_REF_DOF!==undefined && ic.FECHA_ULTIMA_REF_DOF!=="" && ic.FECHA_ULTIMA_REF_DOF!==null ? ic.FECHA_ULTIMA_REF_DOF : "";
                              arc.nombreArchivo= ic.URL_DOCUMENTOS.replace(new RegExp(urlReplace,"g") ,"");
                              arc.nombreArchivo= arc.nombreArchivo.replace(new RegExp(urlReplace2,"g") ,"");
                              arc.listaArchivos= arc.nombreArchivo.split(",");
                              arc.infoAdicional= ic.DESCRIPCION;
                              archivos.push(arc);
                              vig.archivos= archivos;
                              let InsAp= filtroInstApVig.filter((apvg) => apvg.IDNORMATIVAORIG===ic.IDNORMATIVA);
                              InsAp.map((iap)=>{
                                    instAp={};
                                    arcInsAp={};
                                    archivosInsAp=[];
                                    arcInsAp.titulo= iap.TITULO;
                                    arcInsAp.fechaPublicacion=iap.FECHA_PUBLICACION!=="" && iap.FECHA_PUBLICACION!==null ? iap.FECHA_PUBLICACION : "";
                                    arcInsAp.fechaFormato = iap.FECHA!=="" && iap.FECHA!==null ? iap.FECHA : ""
                                    arcInsAp.fechaVigor= iap.FECHA_VIGOR!=="" && iap.FECHA_VIGOR!==null ? iap.FECHA_VIGOR :  "";
                                    arcInsAp.fechaReforma= iap.FECHA_REFORMA!=="" && iap.FECHA_REFORMA!==null ? iap.FECHA_REFORMA : "";
                                    arcInsAp.fechaUltimaRefDof= iap.FECHA_ULTIMA_REF_DOF!==undefined && iap.FECHA_ULTIMA_REF_DOF!=="" && iap.FECHA_ULTIMA_REF_DOF!==null ? iap.FECHA_ULTIMA_REF_DOF : "";
                                    arcInsAp.nombreArchivo= iap.URL_DOCUMENTOS.replace(new RegExp(urlReplace,"g") ,"");
                                    arcInsAp.nombreArchivo= arcInsAp.nombreArchivo.replace(new RegExp(urlReplace2,"g") ,"");
                                    arcInsAp.listaArchivos= arcInsAp.nombreArchivo.split(",");
                                    arcInsAp.infoAdicional= iap.DESCRIPCION;
                                    //archivosInsAp.push(arcInsAp);
                                   // instAp.archivos= archivosInsAp;
                                    instruapoyo.push(arcInsAp);
                              })
                              vig.instruapoyo=instruapoyo;
                              vigentes.push(vig);
                              //instrumento de apoyo
                        })
                        filtroAntDif.map((ic,index)=>{
                              arc={};
                              ant={};
                              archivos=[];
                              instruapoyo=[];
                              let filtroGpoAnt= filtroAnt.filter((ga) => ga.TITULO.trim()=== ic.TITULO.trim());
                              ant.titulo=ic.TITULO;
                              ant.marcojuridico=false;
                              ant.ruta = ic.TEMATICA;
                              filtroGpoAnt.map((gan,index)=>{
                                    arc={};
                                    arc.fechaPublicacion=gan.FECHA_ANTERIORES!=="" && gan.FECHA_ANTERIORES!==null ?  gan.FECHA_ANTERIORES : "";
                                    arc.fechaFormato = gan.FECHA!=="" && gan.FECHA!==null ? gan.FECHA : ""
                                    arc.fechaVigor= "";
                                    arc.fechaReforma= "";
                                    arc.fechaUltimaRefDof="";
                                    arc.nombreArchivo= gan.URL_DOCUMENTOS.replace(new RegExp(urlReplace,"g") ,"");
                                    arc.nombreArchivo= arc.nombreArchivo.replace(new RegExp(urlReplace2,"g") ,"");
                                    arc.listaArchivos= arc.nombreArchivo.split(",");
                                    arc.infoAdicional= gan.DESCRIPCION;
                                    archivos.push(arc);
                              })
                              ant.archivos= archivos;
                              //ant.instruapoyo=instruapoyo;
                              let InsAp= filtroInstApAnt.filter((apant) => apant.IDNORMATIVAORIG===ic.IDNORMATIVA);
                              InsAp.map((iap)=>{
                                    instAp={};
                                    arcInsAp={};
                                    archivosInsAp=[];
                                    arcInsAp.titulo= iap.TITULO;
                                    arcInsAp.fechaPublicacion=iap.FECHA_PUBLICACION!=="" && iap.FECHA_PUBLICACION!==null ? iap.FECHA_PUBLICACION : "";
                                    arcInsAp.fechaFormato = iap.FECHA!=="" && iap.FECHA!==null ? iap.FECHA : ""
                                    arcInsAp.fechaVigor= iap.FECHA_VIGOR!=="" && iap.FECHA_VIGOR!==null ? iap.FECHA_VIGOR :  "";
                                    arcInsAp.fechaReforma= iap.FECHA_REFORMA!=="" && iap.FECHA_REFORMA!==null ? iap.FECHA_REFORMA : "";
                                    arcInsAp.fechaUltimaRefDof= iap.FECHA_ULTIMA_REF_DOF!=="" && iap.FECHA_ULTIMA_REF_DOF!==null ? iap.FECHA_ULTIMA_REF_DOF : "";
                                    arcInsAp.nombreArchivo= iap.URL_DOCUMENTOS.replace(new RegExp(urlReplace,"g") ,"");
                                    arcInsAp.nombreArchivo= arcInsAp.nombreArchivo.replace(new RegExp(urlReplace2,"g") ,"");
                                    arcInsAp.listaArchivos= arcInsAp.nombreArchivo.split(",");
                                    arcInsAp.infoAdicional= iap.DESCRIPCION;
                                    //archivosInsAp.push(arcInsAp);
                                    //instAp.archivos= archivosInsAp;
                                    instruapoyo.push(arcInsAp);
                              })
                              ant.instruapoyo=instruapoyo;
                              //ordenamiento cronológico de fechas de archivos
                              ant.archivos= ant.archivos.sort((a, b) =>
                                    new Date(...a.fechaFormato.split('/').reverse()) - new Date(...b.fechaFormato.split('/').reverse())
                              );
                              anteriores.push(ant);
                        })
                        docCambio.documentosGral=[];
                        docCambio.vigentes= vigentes;
                        docCambio.anteriores= anteriores;
                        docCambio.titulo="";
                        docCambio.introduccion="";
                        docCambio.subtitulo ="";
                  }
                  return (docCambio);
           // })
           // .catch((error) => {
            //      console.log(error);
            //});
    
            
             } catch (error) {
                   console.log("error aut", error);
                   set({setObjError:"Error"});
                   return(get().setObjError); 
             } finally {
                   set( { isLoading: false } );
             } 
   },
   setBusqueda:async(txtBus,infobus)=>{
      try {
                  set({documentos:[]});
                  set({documentosOriginal:[]});
                  let info=infobus;
                  set({indiceInicio:0});
                  set({indiceOrden:0});
                  set({ordenamiento:get().txtOrden + get().tipoOrdenaB[0]});
                  set({infoRes: []});
                  set({marcoJ: {}});
                  set({indiceMarcoJ: -1});
                  set({banVigAnt: "vig"});
                  set({txtBusqueda:txtBus});
                  set({filtrar: get().txtFiltrar + get().tipoFiltro[0]});
                  set({indiceFiltro:0});
                  set({buscaInputValue:""});
                  let indMarcoJuri=-1;
                  if (info.length!==0 || info.hasOwnProperty("vigentes")){

                        if(info.documentosGral!=null && info.documentosGral.length>0){
                              info.documentosGral.map((d)=>{
                                    //cambiar a true para que los intrumentos de apoyo estén visibles al iniciar
                                    d.visualins=false;//true
                              })
                              set({documentos: info.documentosGral});
                              set({banVigAnt: "vig"});
                              indMarcoJuri= info.documentosGral.findIndex((m)=> m.marcojuridico===true);
                              if (indMarcoJuri!==-1){
                                    set({marcoJ: info.documentosGral[indMarcoJuri]});
                                    set({indiceMarcoJ: indMarcoJuri});
                              }
                        }
                        else{
                              if(info.vigentes!=null && info.vigentes.length>0){
                                    info.vigentes.map((d)=>{
                                          //cambiar a true para que los intrumentos de apoyo estén visibles al iniciar
                                          d.visualins=false;//true
                                    })
                                    set({documentos: info.vigentes});
                                    set({banVigAnt: "vig"});
                                    indMarcoJuri= info.vigentes.findIndex((m)=> m.marcojuridico===true);
                                    if (indMarcoJuri!==-1){
                                          set({marcoJ: info.vigentes[indMarcoJuri]});
                                          set({indiceMarcoJ: indMarcoJuri});
                                    }
                              }
                              else  if(info.anteriores!=null && info.anteriores.length>0){
                                          info.anteriores.map((ant)=>{
                                                ant.visual=false;
                                          })
                                          set({documentos: info.anteriores});
                                          indMarcoJuri= info.anteriores.findIndex((m)=> m.marcojuridico===true);
                                          if (indMarcoJuri!==-1){
                                                set({marcoJ: info.anteriores[indMarcoJuri]});
                                                set({indiceMarcoJ: indMarcoJuri});
                                          }
                                    }
                              if((info.vigentes===null || info.vigentes.length===0)  && (info.anteriores!==null || info.anteriores.length>0))
                              {
                                    set({filtrar: get().txtFiltrar + get().tipoFiltro[1]});
                                    set({banVigAnt: "ant"});
                              }
                        }
                        let docs = [...get().documentos];
                        //let docs = [...get().documentos].sort((a, b) =>
                        //                  a.titulo.toLowerCase() > b.titulo.toLowerCase() ? 1 : -1,
                        //      );
                        if (docs.length>get().dispMax){set({pagina0:0});}
                        else{set({pagina0:-1});}
                        set({documentos: docs});
                        set({documentosOriginal: JSON.parse(JSON.stringify(docs))});

                  }
                  set({infoRes: info});
                  set({indiceOrden:0});
             } catch (error) {
                   console.log("error aut", error);
                   set({setObjError:"Error"});
                   return(get().setObjError); 
             } finally {
                   set( { isLoading: false } );
             } 
   },
   //busqueda avanzada
   setBusquedaAva:async(txtBus,infobus)=>{
      
      try {
            //llamada al API
            set({documentos:[]});
            let info=[];
            let docs=[];
            info= infobus;
           // axios.get("./resultBus.json")
           // .then(function (response) {
                 // info= JSON.parse(JSON.stringify(response.data.data));
                  set({indiceInicio:0});
                  
                  set({documentos:[]});
                  set({indiceInicio:0});
                  set({indiceOrden:0});
                  set({ordenamiento:get().txtOrden + get().tipoOrdenaB[0]});
                  //set({ordenamiento:get().txtOrden + get().tipoOrdenaB[0]});
                  set({infoRes: []});
                  set({marcoJ: {}});
                  set({indiceMarcoJ: -1});
                  set({banVigAnt: ""});
                  set({txtBusqueda:txtBus});
                  switch(get().busClasif){
                        case "":
                        case "vigente":
                              set({indiceFiltro:0});
                              set({filtrar: get().txtFiltrar + get().tipoFiltro[0]});
                        break;
                        case "anterior":
                              set({indiceOrden:1});
                              set({filtrar: get().txtFiltrar + get().tipoFiltro[1]});
                        break;
                        default:
                        break;
                  }
                  set({buscaInputValueAva:""});
                  let indMarcoJuri=-1;
                  if(info.length!==0 || info.hasOwnProperty("vigentes")){
                        if(info.documentosGral.length>0){
                              info.documentosGral.map((d)=>{
                                    //cambiar a true para que los intrumentos de apoyo estén visibles al iniciar
                                    d.visualins=false;//true
                              })
                              set({documentos: info.documentosGral});
                              indMarcoJuri= info.documentosGral.findIndex((m)=> m.marcojuridico===true);
                              if (indMarcoJuri!==-1){
                                    set({marcoJ: info.documentosGral[indMarcoJuri]});
                                    set({indiceMarcoJ: indMarcoJuri});
                              }
                        }
                        else{
                              if(info.vigentes.length>0){
                                    info.vigentes.map((d)=>{
                                          //cambiar a true para que los intrumentos de apoyo estén visibles al iniciar
                                          d.visualins=false;//true
                                    })
                                    set({documentos: info.vigentes});
                                    set({banVigAnt: "vig"});
                                    indMarcoJuri= info.vigentes.findIndex((m)=> m.marcojuridico===true);
                                    if (indMarcoJuri!==-1){
                                          set({marcoJ: info.vigentes[indMarcoJuri]});
                                          set({indiceMarcoJ: indMarcoJuri});
                              }
                              }
                              else if(info.anteriores.length>0){
                                          info.anteriores.map((ant)=>{
                                                ant.visual=false;
                                          })
                                          set({documentos: info.anteriores});
                                          set({banVigAnt: "ant"});
                                          indMarcoJuri= info.anteriores.findIndex((m)=> m.marcojuridico===true);
                                          if (indMarcoJuri!==-1){
                                                set({marcoJ: info.anteriores[indMarcoJuri]});
                                                set({indiceMarcoJ: indMarcoJuri});
                                    }
                                    }
                              if((info.vigentes===null || info.vigentes.length===0)  && (info.anteriores!==null || info.anteriores.length>0))
                              {
                                    set({filtrar: get().txtFiltrar + get().tipoFiltro[1]});
                                    set({banVigAnt: "ant"});
                              }
                        }
                        switch(get().busOrden){
                              case "ranking":
                                    set({indiceOrden:0});
                                    set({ordenamiento:get().txtOrden + get().tipoOrdenaB[0]});
                                    docs = [...get().documentos];
                              break;
                              case "titulo":
                                    set({indiceOrden:1});
                                    set({ordenamiento:get().txtOrden + get().tipoOrdenaB[1]});
                                    docs = [...get().documentos].sort((a, b) =>
                                          a.titulo.toLowerCase() > b.titulo.toLowerCase() ? 1 : -1,
                                    );
                              break;
                              case "fechapublicacion":
                                    set({indiceOrden:2});
                                    set({ordenamiento:get().txtOrden + get().tipoOrdenaB[2]});
                                    docs = [...get().documentos].sort((a, b) =>
                                          new Date(...b.archivos[0].fechaFormato.split('/').reverse()) - new Date(...a.archivos[0].fechaFormato.split('/').reverse())
                                    );
                              break;
   
                        }
                        if (docs.length>get().dispMax){set({pagina0:0});}
                        else{set({pagina0:-1});}
                        set({documentosOriginal: JSON.parse(JSON.stringify(get().documentos))});
                        set({documentos: docs});
                        
                  }
                       set({infoRes: info});
                      // set({indiceOrden:0});
                       //console.log("documentos***",get().documentos);
                      // console.log("Original***",get().documentosOriginal);
                  //     return (menu.data);
          //  })
          //  .catch((error) => {
           // console.log(error);
           // });
            } catch (error) {
                   console.log("error aut", error);
                   set({setObjError:"Error"});
                   return(get().setObjError); 
             } finally {
                   set( { isLoading: false } );
             } 
   },
   setFiltro:async(filtro)=>{

      set({ordenamiento:get().txtOrden + get().tipoOrdenaB[0]});
      set({indiceFiltro:filtro});
      set({filtrar: get().txtFiltrar + get().tipoFiltro[filtro]});
   },
   setCambiaInputValueBusca:async(txtvalor)=>{//pendiente
      set({buscaInputValue:txtvalor});
   },
   setCambiaInputValueBuscaAva:async(txtvalor)=>{
      set({buscaInputValueAva:txtvalor});
   },
   setEnviaEncu : async(radInfBus,radFacEnc,numSel,cs,correo,correoNorma)=>{
      const apiurl = process.env.REACT_APP_API_URL; 
      try {
            //llamada a API
            let param={
                  "encontrado" : radInfBus,
                  "facilEnc" : radFacEnc,
                  "recomendacion" : numSel,
                  "comentario" : cs,
                  "correo": correo,
                  "correoNorma": correoNorma
                }
            let header={
                "headers": {
                  "Content-Type": "application/json",
                  "accept": "application/json, text/plain, */*"
              }
            }
            const response = await axios.post(apiurl + 'encuesta/EnviaEncuesta',JSON.stringify(param),header);
            let resp= JSON.parse(JSON.stringify(response.data));
            if(resp==="Ok"){
                  set({envio:true});
                  return(get().envio);
            }
            else{
                  
                  return(get().envio);
            }
            } catch (error) {
                  console.log("error aut", error);
                  set({setObjError:"Error"});
                  return(get().envio); 
            } finally {
                  set( { isLoading: false } );
            } 
   },
   //cerrar los menus del encabezado y materia
   setVisMenuP:async(indi)=>{
      switch(indi){
            case "1"://marco jurídico
                  set({visMenu1:!get().visMenu1});
                  set({visMenu2:false});
                  set({visMenu3:false});
                  set({visMenu4:false});
            break;
            case "2"://marco normativo
                  set({visMenu2:!get().visMenu2});
                  set({visMenu1:false});
                  set({visMenu3:false});
                  set({visMenu4:false});
            break;
            case "3": //manuales
                  set({visMenu3:!get().visMenu3});
                  set({visMenu1:false});
                  set({visMenu2:false});
                  set({visMenu4:false});
            break;
            case "4"://materia
                  set({visMenu4:!get().visMenu4});
                  set({visMenu1:false});
                  set({visMenu2:false});
                  set({visMenu3:false});
                  set({visMenuMovil:false});
            break;
            case "00"://cerrar todos
                  set({visMenu1:false});
                  set({visMenu2:false});
                  set({visMenu3:false});
                  set({visMenu4:false});
                  set({visMenuMovil:false});
            break;
            case "123": //cerrar marco jurídico, marco normativo y manuales
                  set({visMenu1:false});
                  set({visMenu2:false});
                  set({visMenu3:false});
                  set({visMenuMovil:false});
            break;
            case "mt4": //cerrar materia
                  set({visMenu4:false});
            break;
            case "vis4": //si se está navegando en materia mantenerlo abierto
                  set({visMenu4:true});
                  break;
            case "encMovil":
                  set({visMenuMovil:!get().visMenuMovil})
                  set({visMenu1:false});
                  set({visMenu2:false});
                  set({visMenu3:false});
                  set({visMenu4:false});
                  set({visEnc:false});
                  break;
            default:
                  break;
      }
   },
   //abrir-cerrar encuesta
   setVisEnc: async()=>{
      try{
            const env = process.env.REACT_APP_ENV;
            let pathname= window.location.pathname;
            set({visEnc:!get().visEnc});
            set({visMenuMovil:false});
            let llamada= "./recursosJSON/correo.json";
            if (env==="LOCAL"){
                  llamada="./../../../recursosJSON/correo.json";
            }
            if (env==="DES" && (pathname.includes("/menu=") || pathname.includes("/q=") || pathname.includes("/qa="))){
                  llamada="./recursosJSON/correo.json";
            }
            if (get().correoNorma.length===0 || get().correoNorma===undefined){
                  axios.get(llamada)
                  .then(function (response) {
                        if(response.data[0].correoDestino!==undefined){
                              set( {correoNorma: response.data});
                        }
                        else{
                              set( {correoNorma: []});
                              console.log("error en el archivo correo.json");
                        }
                  })
                  .catch((error) => {
                  set({setObjError:"Error"});
                  console.log(error);
                  });
            }
            if(!get().visEnc){set({envio:false})}
      }
      catch (error) {
            console.log("error aut", error);
            set({setObjError:"Error"});
            
      } finally {
            set( { isLoading: false } );
      } 
   },
//llamada="./../../recursosJSON/deInteres.json"; // enlace cuando MAS INFORMACION se visualice en página separada
   setDeInteres: async(opc)=>{
      try{
            const env= process.env.REACT_APP_ENV;
            let llamada= "";
            llamada="./recursosJSON/deInteres.json";
            if (opc==="masInfo" && env==="LOCAL"){
                  llamada="./../../recursosJSON/deInteres.json";
            }
             const response = await  axios.get(llamada);
                  if(response.data[0].img!==undefined){
                        let masInfo = [...response.data].sort((a, b) =>
                              a.descripcion.toLowerCase() > b.descripcion.toLowerCase() ? 1 : -1,
                        );
                        set( {jsonDeInteres: response.data});
                        return(masInfo);
                  }
                  else{
                        set( {jsonDeInteres: []});
                        console.log("error en el archivo deInteres.json");
                        return([]);
                  }
      }
      catch (error) {
            set({setObjError:"Error"});
            console.log("error aut", error);
            return(get().setObjError); 
      } finally {
            set( { isLoading: false } );
      } 
   },
   setMasConsultado: async()=>{
      try{
            let countArray=[12,21,11,35,11,31,34,18,22,14,30,16,20,15,25];
            let classArray =["mc2","mc1-6","mc2-1","mc1-3","mc1-5","mc1-2","mc2-4","mc6","mc2-5","mc2-2","mc1-8","mc1-9","mc1-7","mc1","mc1-4"];

            axios.get("./recursosJSON/masConsultado.json")
            .then(function (response) { 
                  if(response.data[0].value!==undefined){
                        response.data.map((mc,index)=>{
                              let busca= get().jsonMasConsultadoOriginal.find(({value})=>value.trim().toLowerCase() === mc.value.trim().toLowerCase());
                              if (busca!==undefined){
                                    mc.count= countArray[index];
                                    mc.props={"className":classArray[index]};
                                    mc.id=busca.id;
                                    mc.idTipo= busca.idTipo;
                                    mc.inds = busca.inds;
                                    mc.tipo= busca.tipo;
                                    mc.menu= busca.menu;
                                    mc.existe=true;
                              }
                              else{
                                    mc.existe=false;
                              }
                        }) 
                        let filtroMasConsultado= response.data.filter((f)=> f.existe===true);
                        set( {jsonMasConsultado: filtroMasConsultado});
                  }
                  else{
                        set( {jsonMasConsultado: []});
                        console.log("error en el archivo masConsultado.json");
                  }
            })
            .catch((error) => {
            set({setObjError:"Error"});
            console.log(error);
            });
      }
      catch (error) {
            set({setObjError:"Error"});
            console.log("error aut", error);
            return(get().setObjError); 
      } finally {
            set( { isLoading: false } );
      } 
   },
   setMasLeido: async()=>{
      try{
            axios.get("./recursosJSON/masLeido.json")
            .then(function (response) {
                  if(response.data[0].img!==undefined)
                  {set( {jsonMasLeido: response.data});}
                 else{
                  set( {jsonMasLeido: []});
                        console.log("error en archivo masLeido.json");
                  }
                  
            })
            .catch((error) => {
            set({setObjError:"Error"});
            set( {jsonMasLeido: []});
            console.log(error);
            });
      }
      catch (error) {
            set({setObjError:"Error"});
            console.log("error aut", error);
            return(get().setObjError); 
      } finally {
            set( { isLoading: false } );
      } 
   },
   setPublicRecientes: async()=>{
     try{
            const apiurl = process.env.REACT_APP_API_URL; 
            let desimg="";
            let descripTemp="";
            let buscar=" ";
            let indPR=-1;
            let pubGen=false;
            let imgClasif=["acuerdo","reglamento","circular","estatuto","guia","instructivo","ley","lineamiento","manual","normainterna","normatecnica","plantilla","politica","regla","reglamento","codigo","decreto","tratado","otro","publicaciongenerico"];
           
            const response = await axios.post(apiurl + 'inicio/ObtenerPublicaRec');
            response.data.map((pr,index)=>{
                  pubGen=false;
                  descripTemp= pr.descripcion.replace(new RegExp(buscar,"g") ,"");
                  if(descripTemp.trim().toLowerCase().includes("norma")){
                      descripTemp="normainterna";
                  }
                  if(pr.descripcion.trim().toLowerCase().includes("constitución política de los estados unidos mexicanos")){
                        desimg = "cpeum";
                        pr.descripcion="CPEUM";
                  }
                  else if (pr.descripcion.trim().toLowerCase().includes("política") || pr.descripcion.trim().toLowerCase().includes("politica"))
                        { 
                              desimg = "politica";
                              pr.descripcion="Política";
                        }
                        else{
                              indPR= imgClasif.findIndex((ic)=> ic === descripTemp.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
                              if (indPR>-1){
                                    desimg =  imgClasif[indPR];
                              }
                              else{
                                    desimg = descripTemp.toLowerCase().includes("otro")? imgClasif[imgClasif.length-2] : imgClasif[imgClasif.length-1];
                                    pubGen = descripTemp.toLowerCase().includes("otro")? false:true;
                              }
                        }
                  if(!pubGen){
                        pr.img= "pub_" + desimg.toLowerCase() + ".png";
                  }
                  else{
                        pr.img= desimg.toLowerCase() + ".png";
                  }
            }) 
            set( {jsonPublicRecientes: response.data});
            return(response.data);
      }
      catch (error) {
            set({setObjError:"Error"});
            console.log("error aut", error);
            return(get().setObjError); 
      } finally {
            set( { isLoading: false } );
      } 
   },
   setSitiosAfines: async()=>{
      try{
            axios.get("./recursosJSON/sitiosAfines.json")
            .then(function (response) {
                  if(response.data[0].img!==undefined){
                  set( {jsonSitiosAfines: response.data});
                  }
                  else{
                        set( {jsonSitiosAfines: []});
                        console.log("error en el archivo sitiosAfines.json");
                  }
            })
            .catch((error) => {
            set({setObjError:"Error"});
            console.log(error);
            });
           
      }
      catch (error) {
            set({setObjError:"Error"});
            console.log("error aut", error);
            return(get().setObjError); 
      } finally {
            set( { isLoading: false } );
      } 
   },
   loading: async(opc)=>{
      set({openDivLoading: opc});
   },
   setQuitaMatSub: async(opcMS)=>{
      try {
            switch(opcMS){
                  case "m":
                        set({materiaSel:"Materia"});
                        break;
                  case "s":
                        set({submateriaSel:"Submateria"});
                  break;
                  default:
                        break;
            }
      }
      catch (error) {
            set({setObjError:"Error"});
            console.log("error aut", error);
      } finally {
            set( { isLoading: false } );
      } 
   },
   setError: async()=>{
      Swal.fire({//mensaje de 
                          title: "",
                          text: "",
                          showConfirmButton:false,
                          showCancelButton:true,
                          // confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#0077C8',
                          focusCancel:true,
                          // confirmButtonText: 'Continuar',
                          cancelButtonText: 'Cerrar', 
                          html: '<div>A las y los usuarios:</div><div><hr><div>Con motivo de trabajos de mantenimiento, el acceso en algunas secciones, así como los servicios de atención telefónica y en línea, se suspenderán a partir de las 5:00 p. m. del viernes 3 de julio. Los servicios se restablecerán el lunes 6 de julio. Agradecemos su comprensión.</div>'
                          }).then((result) => {
                          if (result.isConfirmed) {
                               return;
                          }
                      }) 
   }
  }));
  
  export default normatecaStore;
